import clsx from 'clsx';
import { Layer, ThemeContext } from 'grommet';

import { LayoutDetector } from '@/components/LayoutDetector';
import { useSelector } from '@/redux/helper';
import { selectShouldShowAppOnboarding } from '@/redux/selectors/users';

import EducatorDetails from './EducatorDetails';
import AppOnboardingProductsOverview from './ProductsOverview';
import AppOnboardingTailorExperience from './TailorExperience';

const localLayerTheme = {
  layer: {
    overlay: {
      background: 'rgba(229, 246, 255, 0.67)',
      backdropFilter: 'blur(10px)',
    },
  },
};

const AppOnboarding = () => {
  const showOnboarding = useSelector(selectShouldShowAppOnboarding);
  const state = useSelector((state) => state.modals.appOnboardingModal);
  const isEducator = state.selectedExperienceOption === 'educator';

  if (!showOnboarding) {
    return null;
  }

  return (
    <LayoutDetector
      title="Onboarding"
      desktop={
        <ThemeContext.Extend value={localLayerTheme}>
          <div className="h-full w-full bg-[url('https://zoolife.tv/assets/onboarding/welcome-desktop-with-opacity.webp')] bg-cover bg-center bg-no-repeat">
            <Layer className="h-[692px] w-96 !rounded-2xl">
              {!state.tailorExperience ? (
                <AppOnboardingTailorExperience />
              ) : isEducator && !state.educatorDetails ? (
                <EducatorDetails />
              ) : !state.productsOverview ? (
                <AppOnboardingProductsOverview />
              ) : null}
            </Layer>
          </div>
        </ThemeContext.Extend>
      }
      mobile={
        <Layer className={clsx('h-svh w-screen !rounded-none mobile:max-h-full mobile:max-w-full')}>
          {!state.tailorExperience ? (
            <AppOnboardingTailorExperience />
          ) : isEducator && !state.educatorDetails ? (
            <EducatorDetails />
          ) : !state.productsOverview ? (
            <AppOnboardingProductsOverview />
          ) : null}
        </Layer>
      }
    />
  );
};

export default AppOnboarding;
